// ----------------------------------------------------------------------

export default function Popover(theme) {
  return {
    MuiPopover: {
      defaultProps: {
        disableScrollLock: true
      },
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z12
        }
      }
    }
  };
}
